import logo from './logo.svg';
import './App.css';

import aminDesktopImg from '../src/assets/imgs/amin-desktop.svg';
import aminMobileImg from '../src/assets/imgs/amin-mobile.svg';
import hamyarDesktopImg from "../src/assets/imgs/hamyar-desktop.svg";
import hamyarMobileImg from "../src/assets/imgs/hamyar-mobile.svg";
import ipLogo from "../src/assets/imgs/ip-logo.svg";
import { site } from './constants';

const list = [
  {
    name: "aminpooshesh",
    img: aminDesktopImg,
    mobileImg: aminMobileImg,
    text: " در راستای چابک سازی شرکت‌های هم‌مجموعه شرکت امداد خودرو و شرکت خصوصی مرکز آمبولانس به شرکت امداد و نجات ایرانیان پوشش ادغام گردیدند و همچنین مؤسسات همیار بیمه، امین پوشش با موسسه حقوقی وکالت و داوری ایرانیان پوشش با برند دادگر بیمه ادغام شدند. مشترکین موسسه امين پوشش به سایت دادگر بیمه به نشانی زیر مراجعه فرمایید.",
  },
  {
    name: "hamyar",
    img: hamyarDesktopImg,
    mobileImg: hamyarMobileImg,
    text: " در راستای چابک سازی شرکت‌های هم‌مجموعه شرکت امداد خودرو و شرکت خصوصی مرکز آمبولانس به شرکت امداد و نجات ایرانیان پوشش ادغام گردیدند و همچنین مؤسسات همیار بیمه، امین پوشش با موسسه حقوقی وکالت و داوری ایرانیان پوشش با برند دادگر بیمه ادغام شدند. مشترکین موسسه همیار بیمه به سایت دادگر بیمه به نشانی زیر مراجعه فرمایید.",
  },
];

function App() {
    let windowWidth = window.screen.width;

  return (
    <div className="bg-white w-full md:w-1/2 rounded-lg md:absolute md:top-1/2 md:left-1/2 md:transform md:-translate-x-1/2 md:-translate-y-1/2 md:grid md:grid-cols-5 flex flex-col-reverse">
      <div className=" md:col-span-3 flex flex-col  items-center justify-center p-6">
        <img src={ipLogo} />
        <span className="font-bold text-lg mt-6 text-myblacks-300">
          با توجه به مصوبه اخیر هیئت مدیره بشماره ۸۶۹:
        </span>
        <span className="text-myblacks-300 text-justify leading-8 mt-4">
          {list.filter((it) => it.name == site)[0].text}
        </span>
        <a className="w-full" target='_blank' href='https://www.dadgarbime.ir'>
          <div className=" bg-[#EFF4FB] flex justify-between items-center p-4 rounded-lg  mt-4 cursor-pointer">
            <span className="text-myblues-300">برای ورود کلیک کنید.</span>
            <span className="text-myblues-300">www.dadgarbime.ir</span>
          </div>
        </a>
      </div>
      <div className="md:col-span-2 p-2">
        <img
        className='w-full'
          src={
            windowWidth > 768
              ? list.filter((it) => it.name == site)[0].img
              : list.filter((it) => it.name == site)[0].mobileImg
          }
        />
      </div>
    </div>
  );
}

export default App;
